import { AffectedStaffQuestionnaire } from '../../lib/types/models/affected-staff-questionnaire/affected-staff-questionnaire'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getAffectedStaffQuestionnaire(affectedStaffId: number) {
  return restApiClient
    .url(
      constructApiUrl(API.affectedStaffs.getAffectedStaffQuestionnaire.url, {
        id: affectedStaffId
      })
    )
    .get<AffectedStaffQuestionnaire>()
}
